/**
 * The evidence-review API may return HTTP 200 after recording a decision even
 * when the separate canonical verification was rejected. Never treat receipt
 * of a review as proof that a certificate has been verified.
 */
export function requireVerifiedTrainingReview(data) {
  const outcome = data?.verification;
  const flagged = outcome?.needs_review?.[0] || outcome?.errors?.[0];
  const verified = outcome?.approved_and_verified || [];
  if (!outcome || flagged || outcome.approved_and_verified_count !== 1 ||
      verified.length !== 1 || !verified[0]?.record_id) {
    throw new Error(
      flagged?.conflict_detail ||
      flagged?.error ||
      'The review was recorded, but this certificate was not verified. Check the mapping, completion date and source document.',
    );
  }
  return {
    renewed: Boolean(verified[0].renewal),
    recordId: verified[0].record_id,
  };
}
